module.exports = __webpack_public_path__ + "assets/img/price.a1597e43.png";